module.exports = __webpack_public_path__ + "img/logo-aafy-header.590ea11a.png";